export default __webpack_public_path__ + "static/media/pdf_fazioni.389cf4c0.png";